import React from 'react';
import SectionRenderer from '../SectionRenderer';

/**
 * StackRenderer - Renders multiple components vertically in a stack
 * Supports any component type that can be rendered by SectionRenderer
 * 
 * Usage in layoutConfig:
 * {
 *   type: 'stack',
 *   width: 8,
 *   title: 'Optional Stack Title',
 *   gap: '1rem', // spacing between items
 *   items: [
 *     { type: 'basic-stat-card', ... },
 *     { type: 'progress-stat-card', ... },
 *     { type: 'grid-stat-card', ... }
 *   ]
 * }
 */
export default function StackRenderer({ section }) {
    const { 
        title, 
        subtitle = '', 
        gap = '1rem',
        items = [],
        theme = {}
    } = section;

    if (!items.length) {
        return (
            <div className="dashboard-new-card">
                <div className="py-6 text-sm text-gray-500">No items in stack</div>
            </div>
        );
    }

    return (
        <div className="h-full w-full">
            {(title || subtitle) && (
                <div className="mb-4">
                    {title && <h3 className="text-base font-medium text-[#641C1A]">{title}</h3>}
                    {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
                </div>
            )}
            
            <div 
                className="w-full h-full flex flex-col gap-4"
            >
                {items.map((item, index) => {
                    const key = item.id ? `${item.id}-${index}` : `stack-item-${index}`;
                    return (
                        <div key={key} className="stack-item flex-grow">
                            <SectionRenderer section={item} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
